import React, { useState } from "react";
import styles from "./Team.module.scss";
import CustomButton from "../../CustomButton/CustomButton";
import TeamTable from "../../Tables/TeamTable/TeamTable";
import TeamModal from "./TeamModal/TeamModal";
import { useTranslation } from "react-i18next";

const Team = () => {
  const [modal, setModal] = useState(false);
  const mochData = true;
  const { t } = useTranslation();

  return (
    <div className={styles.teamContainer}>
      <div className={styles.teamHeader}>
        <CustomButton plus blue width="200px" onClick={() => setModal(true)}>
          {t("team.addEmployeeButton")}
        </CustomButton>
      </div>
      <div className={styles.teamContent}>
        {mochData ? <TeamTable /> : <div>{t("team.noDataFound")}</div>}
      </div>
      {modal && <TeamModal setModal={setModal} />}
    </div>
  );
};

export default Team;
